// src/backgroundImages.js
const backgroundImages = {
  '0,0': '/assets/img2.jpg',
  '1,0': '/assets/img3.jpg',
  '1,1': 'assets/img4.jpg',
  '0,1': 'assets/img5.jpg',
  '0,2': 'assets/img6.jpg',
  '0,3': 'assets/img7.jpg',
  '1,3': 'assets/img8.jpg'
};

export default backgroundImages;
